import React, { useEffect } from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { ProductKeys } from '@atlassiansox/product-store-react';
import { Analytics } from '@trello/atlassian-analytics';
import { UtmCampaign } from 'app/gamma/src/util/cross-flow-essentials';
import {
  OverlayType,
  setOverlay,
} from 'app/gamma/src/modules/state/ui/overlay';

import { defaultStore } from 'app/gamma/src/defaultStore';
import styles from './JSWCrossflowBanner.less';

const illustrationSrc = require('resources/images/jsw-crossflow/intercom.png');
const jswSrc = require('resources/images/jsw-crossflow/jira-software.svg');

const format = forTemplate('directory_crossflow');

export interface JSWCrossflowBannerProps {
  boardId?: string;
}

export const JSWCrossflowBanner: React.FunctionComponent<JSWCrossflowBannerProps> = ({
  boardId,
}) => {
  useEffect(() => {
    Analytics.sendUIEvent({
      action: 'viewed',
      actionSubject: 'banner',
      actionSubjectId: 'jswLearnMoreBanner',
      source: 'boardDirectoryFeaturedScreen',
      containers: boardId ? { board: { id: boardId } } : undefined,
    });
  }, [boardId]);

  const openOverlay = () => {
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'jswLearnMoreButton',
      source: 'boardDirectoryFeaturedScreen',
      containers: boardId ? { board: { id: boardId } } : undefined,
      attributes: {
        windowWidth: window.innerWidth,
      },
    });
    defaultStore.dispatch(
      setOverlay({
        overlayType: OverlayType.ProductStore,
        productKey: ProductKeys.JIRA_SOFTWARE,
        context: {
          source: 'try',
          campaign: UtmCampaign.TOUCHPOINTS_JSW_POWERUPS,
        },
      }),
    );
  };
  return (
    <div className={styles.jswCrossflowBannerContainer}>
      <div className={styles.jswCrossflowBanner}>
        <div className={styles.floatingText}>{format('featured-product')}</div>
        <img src={illustrationSrc} className={styles.illustration} alt="" />
        <div className={styles.copyContainer}>
          <h1 className={styles.bannerHeading}>
            <img alt="Jira Software" src={jswSrc} className={styles.jswLogo} />
          </h1>
          <p className={styles.bannerParagraph}>
            {format('crossflow-description')}
          </p>
        </div>
        <div className={styles.ctaContainer}>
          <PrimaryButton onClick={openOverlay}>
            {format('button-text')}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
